<template>
  <section id="section__apply" class="view-container">
    <div class="width-100">
      <v-row class="section-main-row apply__main" no-gutters>
        <v-col cols="12" class="mb-10 mt-10">
          <p class="mb-10 font--m-5 color--buynow">외상금은 #buy NOW가 알아서 척척!</p>
          <p class="mt-5 font--m-3">외상 구매 신청 완료!</p>
          <img src="@/assets/images/buybox.png" class="buy-img" alt="buy" />
          <p class="mt-10 font--m-5 color--pinkred-110">
            ※ 외상 구매 금액은
            <span class="color--black">1시간 이내</span>
            에
            <br />
            거래상점에서 송금됩니다.
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col :cols="12">
          <BasicButton :to="{ path: '/' }">확인</BasicButton>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
  },
}
</script>

<style lang="scss" scoped>
#section__apply {
  display: flex;
  text-align: center;
  .party-img {
    width: 120px;
    height: 120px;
  }
}
</style>
